const version = {
  version: '1.2.9',
  date: '2026-10-18',
  webBuild: '14',
  webUpdate: ['修复SPA插件的诸多问题', '加回扩展的SVG预览']
};
export default version;
